module.exports = __webpack_public_path__ + "static/img/dev4.c8cf6d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/development/dev4.jpg
// module id = G2es
// module chunks = 0